export const colorCodes = [
  { id: 1, value: "1", label: "Green", colorCode: "#84CC16" },
  { id: 2, value: "2", label: "Orange", colorCode: "#F97316" },
  { id: 3, value: "3", label: "Primary", colorCode: "#6366F1" },
  { id: 4, value: "4", label: "Teal", colorCode: "#06B6D4" },
  { id: 5, value: "5", label: "Yellow", colorCode: "#EAB308" },
];
